import React from "react";
import styles from "./TablePager.module.scss"
import classNames from "classnames";
import numeral from "numeral";
import { ReactComponent as FirstIcon } from "./ic-pagination-first.svg";
import { ReactComponent as PrevIcon } from "./ic-pagination-prev.svg";
import { ReactComponent as NextIcon } from "./ic-pagination-next.svg";
import { ReactComponent as LastIcon } from "./ic-pagination-last.svg";

export default React.memo(({pageRows, rows, pageSize, pageIndex, pageCount, style, className, gotoPage}) => {
    const from = (pageSize * pageIndex) + 1;
    const to = from + pageRows.length - 1;
    const of = numeral(rows.length).format('0,0');

    return <div className={classNames(styles.base, className)} style={style}>
        <div className={styles.counter}>
            {from} - {to} of {of}
        </div>
        <div className={styles.buttons}>
            <button type="button" className={styles.first} disabled={pageIndex === 0} onClick={() => {gotoPage(0)}}><FirstIcon/></button>
            <button type="button" className={styles.prev} disabled={pageIndex === 0} onClick={() => gotoPage(pageIndex - 1) }><PrevIcon/></button>
            <span className={styles.current}>{pageIndex + 1}</span>
            <button type="button" className={styles.next} disabled={pageIndex === pageCount -1 } onClick={() => gotoPage(pageIndex + 1)}><NextIcon/></button>
            <button type="button" className={styles.last} disabled={pageIndex === pageCount -1 } onClick={() => {gotoPage(pageCount - 1)}}><LastIcon/></button>
        </div>
    </div>
});
